export const rootState = {
    connectionStatus: 'online' as 'online' | 'offline'
}
